import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import ProductSlider from '../components/ProductSlider';
import ProductGridSection from '../components/ProductGridSection';
import WhatMakesUsDifferent from '../components/WhatMakesUsDifferent';
import Testimonials from '../components/Testimonials';
import Blogs from '../components/Blogs';
import SEO from '../components/SEO';
import { generateOrganizationSchema, generateWebsiteSchema } from '../lib/structuredData';
import { optimizedAPI } from '../lib/optimizedApi';

export default function Home() {
  const organizationSchema = generateOrganizationSchema();
  const websiteSchema = generateWebsiteSchema();
  const [sliderData, setSliderData] = useState({
    new_arrivals: [],
    dance_dresses: [],
    jewelry: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSliderData = async () => {
      try {
        console.log('Making SINGLE API call for all home sliders...');
        const data = await optimizedAPI.getHomeSliderProducts(8);
        console.log('Received slider data:', data);
        
        // Debug: Check image URLs
        if (data.new_arrivals && data.new_arrivals.length > 0) {
          console.log('Sample product image URL:', data.new_arrivals[0].image);
        }
        setSliderData(data);
      } catch (error) {
        console.error('Error fetching slider data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSliderData();
  }, []);
  
  return (
    <>
      <SEO
        title="BaileBelle - Premium Ballerina Dresses & Jewelry | Dance Wear Collection"
        description="Discover our exquisite collection of premium ballerina dresses, ballet jewelry, and dance accessories. Perfect fit, timeless elegance, and premium quality for every dancer. Shop now!"
        keywords="ballerina dresses, ballet tutus, dance wear, ballet jewelry, dance accessories, premium dance costumes, ballet leotards, dance shoes, ballerina outfits, dance clothing"
        url="/"
        structuredData={[organizationSchema, websiteSchema]}
      />
      <div className="min-h-screen">
        <HeroSection />
        <ProductSlider 
          title="New Arrivals"
          products={sliderData.new_arrivals}
          loading={loading}
          buttonText="View All New Arrivals"
          buttonLink="/collections?sort=date"
        />
        <ProductSlider 
          title="Latin Dress Costumes"
          products={sliderData.dance_dresses}
          loading={loading}
          buttonText="View All Latin Dresses"
          buttonLink="/collections/latin-dress"
        />
        <ProductSlider 
          title="Jewelry"
          products={sliderData.jewelry}
          loading={loading}
          buttonText="View All Jewelry"
          buttonLink="/collections/jewelry"
        />
        {/* <ProductGridSection /> */}
        <WhatMakesUsDifferent />
        <Testimonials />
        <Blogs />
      </div>
    </>
  );
}
